module.exports = "/static/media/ac_admin_empty_table.ffc377de.svg";